import React from "react";
import flag_2 from "./../assets/img/tarh-parcham-iran-psdtarh2.png";
import { ApiEndpoints, useApiCall } from "../api";
import MainLayout from "../layout/main";
import CartIcon from "../assets/img/Union (2).svg";
import CartIcon2 from "../assets/img/Union.svg";
import CartIcon3 from "../assets/img/Union (1).svg";
import CartIcon4 from "../assets/img/Union (3).svg";
import StaticCard from "../component/StaticCard";
import { storageApi } from "../storage/storageApi";

const StatisticalReportsPage = () => {
  const [[reportList], { loading }] = useApiCall({
    endpoints: ApiEndpoints.statistical.report,
  });
  const userProfile = storageApi.useGetUser();
  const handleHeaderCard = () => {
    switch (userProfile.role) {
      case "customer":
        return "رتبه کاربر در سازمان";
      case "state_manager":
        return "تعداد دستگاه های فعال در استان";
      case "organization_manager":
        return "تعداد استان های فعال";
      case "state_organization_manager":
        return "رتبه سازمان در استان";
      case "admin":
        return "تعداد سازمان های فعال";
    }
  };

  const handleHeaderCardEnd = () => {
    switch (userProfile.role) {
      case "customer":
        return "رتبه کاربر در کل کشور";
      case "state_manager":
        return "رتبه در کل کشور";
      case "organization_manager":
        return "رتبه در کل کشور";
      case "state_organization_manager":
        return "رتبه استان در کشور";
      case "admin":
        return "تعداد مجموعه های فعال";
    }
  };

  const handleDescriptionCard = () => {
    switch (userProfile.role) {
      case "customer":
        return " بر اساس امتیاز کسب شده";
      case "state_manager":
        return " بر اساس برنامه ثبت شده";
      case "organization_manager":
        return "";
      case "state_organization_manager":
        return " بر اساس امتیاز کسب شده";
      case "admin":
        return " بر اساس برنامه ثبت شده";
    }
  };

  const handleProgramCardValue = () => {
    switch (userProfile.role) {
      case "customer":
        return reportList?.data?.user_programs_count;
      case "state_manager":
        return reportList?.data?.state_programs_count;
      case "organization_manager":
        return reportList?.data?.sazman_programs_count;
      case "state_organization_manager":
        return reportList?.data?.sazman_state_programs_count;
      case "admin":
        return reportList?.data?.all_programs_count;
    }
  };

  const handleReportCardValue = () => {
    switch (userProfile.role) {
      case "customer":
      case "state_manager":
      case "organization_manager":
      case "state_organization_manager":
      case "admin":
        return reportList?.data?.confirmed_programs_count;
    }
  };

  const handleScoreCardValue = () => {
    switch (userProfile.role) {
      case "customer":
        return reportList?.data?.total_score;
      case "state_manager":
        return reportList?.data?.total_score_of_state;
      case "organization_manager":
        return reportList?.data?.total_score_of_sazman;
      case "state_organization_manager":
        return reportList?.data?.total_score_of_sazman_state;
      case "admin":
        return reportList?.data?.total_score_of_all_programs;
    }
  };

  const handleUsersCardValue = () => {
    switch (userProfile.role) {
      case "customer":
        return reportList?.data?.province_rank;
      case "state_manager":
        return reportList?.data?.state_users_count;
      case "organization_manager":
        return reportList?.data?.sazman_users_count;
      case "state_organization_manager":
        return reportList?.data?.sazman_state_users_count;
      case "admin":
        return reportList?.data?.all_users_count;
    }
  };

  const handleActiveUsersCardValue = () => {
    switch (userProfile.role) {
      case "customer":
        return reportList?.data?.org_province_rank;
      case "state_manager":
        return reportList?.data?.state_active_users_count;
      case "organization_manager":
        return reportList?.data?.sazman_active_users_count;
      case "state_organization_manager":
        return reportList?.data?.sazman_state_active_users_count;
      case "admin":
        return reportList?.data?.active_users_count;
    }
  };

  const handleProvinceCardValue = () => {
    switch (userProfile.role) {
      case "customer":
        return reportList?.data?.organization_rank;
      case "state_manager":
        return reportList?.data?.orgs_with_programs_count;
      case "organization_manager":
        return reportList?.data?.states_with_programs_count;
      case "state_organization_manager":
        return reportList?.data?.sazman_in_state_rank;
      case "admin":
        return reportList?.data?.sazman_with_programs_count;
    }
  };

  const handleRankCardValue = () => {
    switch (userProfile.role) {
      case "state_manager":
        return reportList?.data?.state_rank;
      case "organization_manager":
        return reportList?.data?.sazman_rank;
      case "customer":
        return reportList?.data?.total_rank;
      case "state_organization_manager":
        return reportList?.data?.sazman_state_rank;
      case "admin":
        return reportList?.data?.majmooe_with_programs_count;
    }
  };

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative p-8 min-h-[180px]">
          <img src={flag_2} className=" absolute left-0 top-0 h-42" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] h-full mx-auto">
            <div className="text-3xl text-center font-bold">
              <span className=" text-greenblue">گزارش آماری</span>
            </div>
          </div>
        </div>
        <div>
          <div className="md:px-12 px-8 md:py-8 py-4 grid md:grid-cols-3 grid-cols-1 md:gap-8 gap-4">
            <StaticCard
              cardHeader={
                userProfile.role === "customer"
                  ? "تعداد فعالیت های ثبت شده"
                  : "تعداد برنامه های پیش بینی شده"
              }
              cardNumber={handleProgramCardValue() | "-"}
              cardIcon={CartIcon}
              description="کل فعالیت ها"
              cardColor="blue"
            />
            <StaticCard
              cardHeader={
                userProfile.role === "customer"
                  ? "تعداد فعالیت های گزارش شده"
                  : "تعداد گزارش های تایید شده"
              }
              cardSubHeader={
                userProfile.role === "customer" ? "(تایید شده)" : "(اجرا شده)"
              }
              cardNumber={handleReportCardValue() | "-"}
              cardIcon={CartIcon2}
              description=" فعالیت تایید شده"
              cardColor="blue"
            />
            <StaticCard
              cardHeader="مجموع امتیاز"
              cardSubHeader={
                userProfile.role === "customer"
                  ? "(گزارش تایید شده)"
                  : "(بر اساس گزارش تایید شده)"
              }
              cardNumber={handleScoreCardValue() | "-"}
              cardIcon={CartIcon3}
              description=" مجموع امتیازات"
              cardColor="blue"
            />
            <StaticCard
              cardHeader={
                userProfile.role === "customer"
                  ? "رتبه کاربر در استان"
                  : "تعداد کاربران ثبت نام شده"
              }
              cardNumber={handleUsersCardValue() | "-"}
              cardIcon={CartIcon4}
              description={
                userProfile.role === "customer" && " بر اساس امتیاز کسب شده"
              }
              cardColor="error"
            />
            <StaticCard
              cardHeader={
                userProfile.role === "customer"
                  ? "رتبه کاربر در سازمان"
                  : "تعداد کاربران فعال"
              }
              cardSubHeader={userProfile.role === "customer" && "(در استان)"}
              cardNumber={handleActiveUsersCardValue() | "-"}
              cardIcon={CartIcon4}
              description={
                userProfile.role === "customer" && " بر اساس امتیاز کسب شده"
              }
              cardColor="error"
            />
            <StaticCard
              cardHeader={handleHeaderCard()}
              cardSubHeader={
                userProfile.role === "customer" ? "(در کل کشور)" : null
              }
              cardNumber={handleProvinceCardValue() | "-"}
              cardIcon={CartIcon4}
              description={handleDescriptionCard()}
              cardColor="error"
            />
            <StaticCard
              cardHeader={handleHeaderCardEnd()}
              cardSubHeader={
                userProfile.role === "state_organization_manager"
                  ? "(سازمان تابعه)"
                  : null
              }
              cardNumber={handleRankCardValue() | "-"}
              cardIcon={CartIcon4}
              description={
                userProfile.role !== "admin"
                  ? " بر اساس امتیاز کسب شده"
                  : " بر اساس برنامه ثبت شده"
              }
              cardColor="error"
              isCenter={true}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default StatisticalReportsPage;
